import QrcodeDiv from '../../shared/QrcodeDiv.js';
import StampDateConverter from '../../converter/StampDateConverter.js';
import StockinfoConverter from '../../converter/StockinfoConverter.js';

function PanelRedeemInfo_CouponStamp(props) {
    let startDate = new Date(props.data.Stamp_Start_Date);
    let endDate = new Date(props.data.Stamp_End_Date);
    let today = new Date();
    let Difference_In_Time = startDate.getTime() - today.getTime();
    let Difference_In_Days = Math.round(Difference_In_Time / (1000 * 3600 * 24));

    const shopImageUrl = process.env.REACT_APP_URL_IMAGE_COMMON+ "mainShopAddress.jpg";
    const shopImage = `<div className="pickup-logo"><img style="max-width: 100%" src='${shopImageUrl}' /></div>`;

    return (
        <>

            <div className="np-effective-info" style={{backgroundColor: props.data.allTitle_FontColor}}>
                    <span>印花詳情 : </span>
                    <b>{props.stock.map((item) => <StockinfoConverter data={item}></StockinfoConverter>)}</b>
            </div>
                    
            <div className="np-effective-info" style={{backgroundColor: props.data.allTitle_FontColor}}>
                    
                    <span>印花有效期 : </span>
                    <b>{
                        props.data.Stamp_Start_Date != props.data.Stamp_End_Date &&
                        <span>
                            <br></br>
                            <span>由</span>
                            <StampDateConverter data={props.data.Stamp_Start_Date}></StampDateConverter>
                            <br></br>
                            <span>至</span>
                            <StampDateConverter data={props.data.Stamp_End_Date}></StampDateConverter>
                        </span>
                    }
                    {
                        props.data.Stamp_Start_Date == props.data.Stamp_End_Date &&
                        <span>
                            <StampDateConverter data={props.data.Stamp_Start_Date}></StampDateConverter>
                        </span>
                    }
                    </b>
                </div>

                <div className="np-effective-info" style={{backgroundColor: props.data.allTitle_FontColor}}>
                    <span>使用印花分店 : </span>
                    <b>{props.data.Pickup_Adress}</b>
                    <div dangerouslySetInnerHTML={{__html: shopImage}} />
                </div>
                    
            
                <div>
                    <div className="qrcode-logo">
                        <QrcodeDiv stamp_code={props.data.Stamp_Prefix + props.data.Stamp_Code} stamp_icon={props.data.Stamp_QRCode_Icon}/>
                    </div>
                    <div className="qrcode-number">
                        <span>{props.data.Stamp_Code}</span>
                    </div>
                    <div className="screencap-info">
                        <br></br>
                        <span>如有需要，請將本頁截圖!</span>
                        <br></br>
                        <br></br>
                    </div>
                </div>

        </>
    );
}

export default PanelRedeemInfo_CouponStamp;